import { Divider } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { AiOutlineDown } from 'react-icons/ai'
import { BiDownArrow } from 'react-icons/bi'
import { useHistory } from 'react-router'
// import { Link } from 'react-scroll'

const useStyles = makeStyles((theme) => ({
  navLink: {
    fontWeight: theme.typography.fontWeightBold,
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'white',
    // '&:hover': {
    //   transition: 'all 0.4s ease 0s',
    //   // color: theme.palette.primary.main,
    //   // borderBottom: '1px solide black',
    // },
    fontSize: '16px',
    marginTop: '20px',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: '15px',
      marginTop: '0px',
      marginLeft: '22px',

    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '17px',
      marginLeft: '40px',
      // paddingTop: '5px',
    },
  },
  dropDown: {
    margin: 0,
    padding: 0,
    textDecoration: 'none',
    '&:hover': {},
    // [theme.breakpoints.up('lg')]: {
    //   backgroundColor: theme.palette.secondary.dark,
    // },
  },
  dropDownList: {
    cursor: 'pointer',
    [theme.breakpoints.up('lg')]: {
      fontSize: '16px',
      textAlign: 'center',
      padding: '10px',
      // '&:hover': {
      //   backgroundColor: theme.palette.info.main,
      //   // boxShadow: '10px 10px 50px grey',
      // },
    },
  },

  active: {
    // '&:hover': {
    transition: 'all 0.4s ease 0s',
    // color: theme.palette.primary.main,
    // },
  },
}))

export default function CustomDropdown({ menuItems, listName, active, to }) {
  const classes = useStyles()
  const history = useHistory()

  const renderListItem =
    menuItems && listName ? (
      <li style={{ listStyle: 'none' }}>
        <div
          class="nav-link dropdown-toggle"
          href="#"
          id="navbarDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          className={active ? classes.navLink + ' ' + classes.active : classes.navLink}
        >
          {listName} {<AiOutlineDown />}
        </div>
        <ul className={`dropdown-menu ${classes.dropDown}`} aria-labelledby="navbarDropdown">
          {menuItems.map((item, index) => {
            return (
              <>
                <li style={{ listStyle: 'none' }}>
                  {item.to ? (
                    <div className={`dropdown-item ${classes.dropDownList}`} to={item.to}>
                      {item.item}
                    </div>
                  ) : (
                    <div className={`dropdown-item ${classes.dropDownList}`} onClick={() => history.push(item.url)}>
                      {item.item}
                    </div>
                  )}
                </li>
              </>
            )
          })}
        </ul>
      </li>
    ) : (
      <>
        {to ? (
          <div to={to} className={active ? classes.navLink + ' ' + classes.active : classes.navLink}>
            {listName}
          </div>
        ) : (
          <>
            <div className={active ? classes.navLink + ' ' + classes.active : classes.navLink}>{listName}</div>
          </>
        )}
      </>
    )
  return renderListItem
}
